<template>
  <v-main align="center">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="10">
          <v-card class="elevation-12">
            <formula-toolbar :title="$t('formula.toolbarTitle')" />
            <router-view />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import FormulaToolbar from "../components/formula/FormulaToolbar.vue";
export default {
  name: "FormulaView",
  components: {
    FormulaToolbar,
  },
};
</script>
